import { useMemo } from 'react';
import { DeviceActionProps } from '@components/Actions/ActionsModal/types';
import ActionTypes from '@utils/deviceActions';
import { IDevice } from '@pages/Assets/Inventory/types';

interface MotDeactivationPayloadProps {
  action: ActionTypes.MOT_DEACTIVATION;
  devices: {
    msisdn: string;
    iccid: string;
  }[];
}

interface MotDeactivationProps {
  devices: IDevice[];
  isUpload?: boolean;
}

const useMotDeactivation = ({
  devices,
  isUpload,
}: MotDeactivationProps): DeviceActionProps => {
  const payloadToSend = useMemo(
    (): MotDeactivationPayloadProps => ({
      action: ActionTypes.MOT_DEACTIVATION,
      devices: isUpload
        ? devices
        : devices?.map(device => ({
            msisdn: device.msisdn,
            iccid: device.iccid,
          })),
    }),
    [devices, isUpload],
  );

  return {
    steps: [],
    payloadToSend,
  };
};

export default useMotDeactivation;
